// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, sendEmailVerificationCodeApi } from "../../Utils/Constants";

export const hitSendEmailVerificationCode = createAsyncThunk("hitSendEmailVerificationCode", async (payload) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    };
    const url = ApiBaseUrl + sendEmailVerificationCodeApi;
    const response = await axios.post(url, payload, config);
    return response.data;
  } catch (error) {
    alert(error.response.data.message);
    throw error.response.data;
  }
});

const EmailVerificationCodeSlice = createSlice({
  name: "emailVerificationCodeReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearEmailVerificationCodeData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitSendEmailVerificationCode.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitSendEmailVerificationCode.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitSendEmailVerificationCode.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearEmailVerificationCodeData } = EmailVerificationCodeSlice.actions;
export default EmailVerificationCodeSlice.reducer;
